import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../assets/fondos/3.jpg";
import WhatsAppButton from "../components/WhatsAppButton";
import LandingChatbot from "../components/LandingChatbot";
import { Helmet } from "react-helmet";
import cirpImage from "../assets/img/cirp_icon.png";
import useFacebookPixel from "../hooks/useFacebookPixel";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./usuario.css";
import "./recuadro.css";
import SocialButtons from "../components/SocialButton";
import MicrosoftClarity from '../components/MicrosoftClarity';


const Usuario = () => {
  const { usuario } = useParams();
  useFacebookPixel(usuario);
  const { trackContact, trackViewContent, CompleteRegistration,trackLead } =
    useFacebookPixel(usuario);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [userdata, setUserdata] = useState({});
  const [Pixels, setPixels] = useState("");
  const [Clarity, setClarity] = useState("");
  const [encuesta, setencuesta] = useState("");
  const [played, setPlayed] = useState(0);
  const [showQuestion, setShowQuestion] = useState(false);
  const [showReplayButton, setShowReplayButton] = useState(false);
  const [modal, setModal] = useState(true);
  const [surveyCompleted, setSurveyCompleted] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    correo: "",
    telefono: "",
  });
  const [error, setError] = useState(false);
  const playerRef = useRef(null);

  // Obtener el ID del usuario logueado desde el almacenamiento local
  const loginUserJSON = window.localStorage.getItem("loginUser");
  const loggedInUser = loginUserJSON ? JSON.parse(loginUserJSON) : null;
  const userId = loggedInUser ? loggedInUser.id : null;
  const userRole = loggedInUser ? loggedInUser.rol : null;
  const userWS = loggedInUser ? loggedInUser.tlfwhatsapp : null;
  
const hasAnySocialLink = 
  (userdata && userdata.pdf) || 
  (userdata && userdata.facebook) || 
  (userdata && userdata.instagram) || 
  (userdata && userdata.linkedin) || 
  (userdata && userdata.tiktok) || 
  (userdata && userdata.calendly);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/usuariolanding/${usuario}`
        );
        setData(response.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/infocampanas/${usuario}`
        );
        setUserdata(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const pixelsuser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/userpixels/${usuario}`
        );
        setPixels(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const clarityuser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/userclarity/${usuario}`
        );
        setClarity(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const encuestauser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/encuestacampana/${usuario}`
        );
        setencuesta(response.data[0]);
       
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchData();
    fetchUserInfo();
    pixelsuser();
    encuestauser();
    clarityuser();
  }, [usuario]);

  const handleProgress = (state) => {
    if (!playerRef.current.seeking) {
      setPlayed(state.played);
    } else {
      playerRef.current.seekTo(played);
    }
  };

  const handleEnded = () => {
    setShowQuestion(true);
    setShowReplayButton(true);
  };

  const handleReplay = () => {
    setShowQuestion(false);
    setShowReplayButton(false);
    playerRef.current.seekTo(0);
  };

  const handleOptionA = () => {
    trackViewContent();
    navigate(`/producto1/${usuario}`);
  };

  const handleOptionB = () => {
    trackViewContent();
    navigate(`/negocio1/${usuario}`);
  };

  const handleOptionC = () => {
    navigate("/salir");
  };

  const handleBack = () => {
    if (userRole === "admin") {
      navigate("/inicio");
    } else if (userRole === "cliente") {
      navigate("/iniciouser");
    } else {
      navigate(-1);
    }
  };

  const handleSurveyResponse = (response) => {
    setSurveyCompleted(true);

    switch (response) {
      case "interested":
        trackViewContent();
        break;
      case "more_info":
        trackViewContent();
        break;
      default:
        break;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, telefono: value });
  };

const peticionPost = async () => {
    const nuevoLeadConUsuario = {
        ...formData,
        iduser: userdata?.creador,
        usuario: usuario,
        correodestinario: userdata?.correo,
    };

    // Mostrar los datos que se van a enviar
    console.log("Datos a enviar:", nuevoLeadConUsuario);

    try {
        // Primera petición
        console.log("Enviando datos a leadsnuevos...");
        const res1 = await axios.post(
            "https://api.mrcirp.com/public/leadsnuevos",
            nuevoLeadConUsuario,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        console.log("Respuesta de leadsnuevos:", res1.data);

        // Segunda petición
        console.log("Enviando datos a enviarcorreoleads...");
        const res2 = await axios.post(
            "https://api.mrcirp.com/enviarcorreoleads.php",
            nuevoLeadConUsuario,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        console.log("Respuesta de enviarcorreoleads:", res2.data);

        CompleteRegistration();
        setError(false);
        setModal(false);
    } catch (err) {
        console.error("Error submitting form:", err);
        setError(true);
    }
};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.correo || !formData.telefono) {
      alert("Por favor, completa todos los campos.");
      return;
    }
    peticionPost();
  };

  if (!data) {
    return <div>Loading...</div>;
  }


  return (
    <div style={styles.container}>
      <Helmet>
        <title>{usuario}</title>
        <meta name="description" content={`Pixels: ${Pixels}`} />
      </Helmet>
   {Clarity?.clarity && <MicrosoftClarity trackingId={Clarity.clarity} />}
      <div style={styles.content}>
        <h1>{data.nombrecampana}</h1>
        <p>{data.descripcion}</p>
        <div className="row">
          <div
            className={
              showQuestion ? "col-md-6 col-sm-12" : "col-md-12 col-sm-12"
            }
          >
            <div style={styles.videoWrapperFull}>
              <div style={styles.videoWrapper}>
                {!showReplayButton && data.urlvideo ? (
                  <ReactPlayer
                    ref={playerRef}
                    url={data.urlvideo}
                    width="100%"
                    height="100%"
                    controls={false}
                    onProgress={handleProgress}
                    onEnded={handleEnded}
                    style={styles.video}
                  />
                ) : (
                  <div className="recuadro" style={styles.replayContainer}>
                    <img
                      src={cirpImage}
                      alt="CIRP"
                      style={styles.replayImage}
                    />
                    <button style={styles.button} onClick={handleReplay}>
                      Reproducir nuevamente
                    </button>
                  </div>
                )}
              </div>

              {encuesta && (
  <div className="recuadro" style={styles.surveyContainer}>
    {surveyCompleted ? (
      <div style={styles.thankYouMessage}>
        <h4>¡Gracias por tu respuesta!</h4>
        <p>Valoramos mucho tu opinión.</p>
      </div>
    ) : (
      
      <>
        <h4>{encuesta.pregunta}</h4>
        <div style={styles.surveyButtons}>
          <button
            style={styles.surveyButton}
            onClick={() => {
              if (encuesta.evento_1 === "cliente potencial") {
                trackLead();
              }
              setSurveyCompleted(true);
            }}
          >
            {encuesta.respuesta_1}
          </button>
          <button
            style={styles.surveyButton}
            onClick={() => {
              if (encuesta.evento_2 === "cliente potencial") {
                trackLead();
              }
              setSurveyCompleted(true);
            }}
          >
            {encuesta.respuesta_2}
          </button>
          <button
            style={styles.surveyButton}
            onClick={() => {
              if (encuesta.evento_3 === "cliente potencial") {
                trackLead();
              }
              setSurveyCompleted(true);
            }}
          >
            {encuesta.respuesta_3}
          </button>
        </div>
      </>
    )}
  </div>
)}
            </div>
          </div>

          {showQuestion && (
            <div className="col-md-6 col-sm-12">
              <div className="recuadro" style={styles.question}>
                <h4>
                  ¿Qué le pareció el video? … ¿Sorprendente cierto? ¿Como deseas
                  continuar?
                </h4>
                <button style={styles.button} onClick={handleOptionA}>
                  A) SÍ QUIERO MÁS INFORMACIÓN DEL PRODUCTO
                </button>
                <button style={styles.button} onClick={handleOptionB}>
                  B) QUIERO CONOCER MÁS DEL NEGOCIO
                </button>
                <button style={styles.button} onClick={handleOptionC}>
                  C) NO GRACIAS, DESEO SALIR
                </button>
                <button style={styles.button} onClick={handleBack}>
                  VOLVER
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <WhatsAppButton
        phoneNumber={userdata?.whatsapp}
        message="Hola, me gustaría obtener más información."
        onContactClick={trackContact}
      />
      
      <LandingChatbot />
      
{hasAnySocialLink && (
  <SocialButtons
    pdfUrl={userdata?.pdf || undefined}  // Si está vacío, pasa `undefined`
    facebookUrl={userdata?.facebook || undefined}
    instagramUrl={userdata?.instagram || undefined}
    linkedinUrl={userdata?.linkedin || undefined}
    tiktokUrl={userdata?.tiktok || undefined}
    calendlyUrl={userdata?.calendly || undefined}
    onContactClick={(network) => console.log(`Se hizo clic en ${network}`)}
  />
)}

      <Modal isOpen={modal} centered>
        <ModalHeader style={{ position: "relative" }}>
          <div
            style={{
              position: "absolute",
              right: "20px",
              top: "15px",
              cursor: "pointer",
              zIndex: 1,
            }}
            onClick={() => setModal(false)}
          >
            ×
          </div>
          <h6 style={{ textAlign: "center", paddingRight: "30px" }}>
            {userdata?.texto_modal}
          </h6>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="nombre">Nombre</Label>
              <Input
                type="text"
                name="nombre"
                id="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="correo">Correo Electrónico</Label>
              <Input
                type="email"
                name="correo"
                id="correo"
                value={formData.correo}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="telefono">Teléfono</Label>
              <PhoneInput
                international
                defaultCountry="PE"
                value={formData.telefono}
                onChange={handlePhoneChange}
                placeholder="Ingresa tu número de teléfono"
                style={{ width: "100%" }}
                className="custom-phone-input"
              />
            </FormGroup>
            <Button type="submit" color="primary" style={{ width: "100%" }}>
              Enviar
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${bannerImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    padding: "20px",
    color: "#fff",
  },
  content: {
    textAlign: "center",
    maxWidth: "1200px",
    width: "100%",
  },
  videoWrapperFull: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    padding: "20px 0",
  },
  videoWrapper: {
    position: "relative",
    width: "80%",
    paddingTop: "45%",
    margin: "0 auto",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  question: {
    width: "100%",
    marginTop: "20px",
    padding: "20px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    borderRadius: "10px",
  },
  button: {
    display: "block",
    margin: "10px auto",
    padding: "12px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#fff",
    color: "#000",
    border: "none",
    borderRadius: "5px",
    transition: "background-color 0.3s, color 0.3s",
    width: "90%",
    maxWidth: "400px",
  },
  replayContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    borderRadius: "10px",
  },
  replayImage: {
    width: "150px",
    marginBottom: "20px",
  },
  surveyContainer: {
    marginTop: "20px",
    padding: "20px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    borderRadius: "10px",
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  surveyButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "15px",
  },
  surveyButton: {
    padding: "12px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#2196F3", // Azul uniforme para todos los botones
    color: "white",
    border: "none",
    borderRadius: "5px",
    transition: "background-color 0.3s",
    width: "100%",
  },
  thankYouMessage: {
    padding: "20px",
    textAlign: "center",
    color: "#fff",
  },
};

export default Usuario;
